import { render, staticRenderFns } from "./default-menu-form.vue?vue&type=template&id=764cb798&"
import script from "./default-menu-form.vue?vue&type=script&lang=js&"
export * from "./default-menu-form.vue?vue&type=script&lang=js&"
import style0 from "./default-menu-form.vue?vue&type=style&index=0&id=764cb798&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports